import { FC, useState } from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { AddUserModal, SearchInput } from 'components';

export const CustomerListToolbar: FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <div className={'flex w-full justify-between'}>
      <div className={'flex-1'}>
        <SearchInput loading={false} onSearchResult={() => ({})} placeholder='Search Users' />
      </div>
      <div className={'m-1'}>
        <Button color='primary' variant='contained' onClick={() => setOpen(true)}>
          <AddIcon /> Add User
        </Button>
      </div>

      <AddUserModal open={open} handleClose={() => setOpen(false)} />
    </div>
  );
};
